import { CommonModule } from '@angular/common';
import { Component, VERSION as VERSION_ANGULAR, inject } from '@angular/core';
import { I18NService } from '@core';
import { VERSION as VERSION_ALAIN, I18nPipe, ALAIN_I18N_TOKEN } from '@delon/theme';
import { environment } from '@env/environment';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { VERSION as VERSION_ZORRO } from 'ng-zorro-antd/version';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

@Component({
  selector: 'header-version-info',
  template: `
    <nz-modal
      [(nzVisible)]="visible"
      [nzTitle]="'version.title' | i18n"
      [nzFooter]="null"
      (nzOnCancel)="visible = false"
      nzWidth="500px"
      [testId]="'version-info-modal'"
    >
      <ng-container *nzModalContent>
        <div class="ant-descriptions ant-descriptions-bordered" [testId]="'version-descriptions'">
          <div class="ant-descriptions-view">
            <table>
              <tbody>
                <tr class="ant-descriptions-row">
                  <td class="ant-descriptions-item-label" [testId]="'app-version-label'">{{ 'version.app-version' | i18n }}</td>
                  <td class="ant-descriptions-item-content" [testId]="'app-version-item'">
                    <nz-tag nzColor="blue" [testId]="'app-version-tag'">{{ appVersion }}</nz-tag>
                  </td>
                </tr>
                <tr class="ant-descriptions-row">
                  <td class="ant-descriptions-item-label" [testId]="'angular-version-label'">{{ 'version.angular-version' | i18n }}</td>
                  <td class="ant-descriptions-item-content" [testId]="'angular-version-item'">
                    <nz-tag nzColor="green" [testId]="'angular-version-tag'">{{ angularVersion }}</nz-tag>
                  </td>
                </tr>
                <!-- <tr class="ant-descriptions-row">
                  <td class="ant-descriptions-item-label">{{ 'version.alain-version' | i18n }}</td>
                  <td class="ant-descriptions-item-content">
                    <nz-tag nzColor="orange">{{ alainVersion }}</nz-tag>
                  </td>
                </tr>
                <tr class="ant-descriptions-row">
                  <td class="ant-descriptions-item-label">{{ 'version.zorro-version' | i18n }}</td>
                  <td class="ant-descriptions-item-content">
                    <nz-tag nzColor="purple">{{ zorroVersion }}</nz-tag>
                  </td>
                </tr> -->
                <tr class="ant-descriptions-row">
                  <td class="ant-descriptions-item-label" [testId]="'build-time-label'">{{ 'version.build-time' | i18n }}</td>
                  <td class="ant-descriptions-item-content" [testId]="'build-time-item'">
                    <span [testId]="'build-time-text'">{{ buildTime }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </nz-modal>
  `,
  imports: [CommonModule, NzModalModule, NzButtonModule, NzIconModule, NzDescriptionsModule, NzTagModule, TestIdDirective, I18nPipe]
})
export class HeaderVersionInfoComponent {
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  visible = false;

  // 從環境變量獲取版本號
  appVersion = environment['appVersion'] || '0.0.3';

  // 獲取框架版本
  angularVersion = VERSION_ANGULAR.full;
  alainVersion = VERSION_ALAIN.full;
  zorroVersion = VERSION_ZORRO.full;

  // 構建時間（從環境變量獲取，如果沒有則使用當前時間）
  buildTime = this.getBuildTime();

  private getBuildTime(): string {
    // 優先使用環境變量中的構建時間
    if (environment['buildTime']) {
      return new Date(environment['buildTime']).toLocaleString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    // 如果沒有環境變量，使用當前時間作為fallback
    return new Date().toLocaleString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  show(): void {
    this.visible = true;
  }
}
